module.exports = __webpack_public_path__ + "img/how-it-works-video-thumb2.1b82efc9.png";